import { Money, OdometerUnit } from 'models/common';

import { PluginItem } from '../pluginItem';
import { ReconVelocityDealershipCosts } from './index';
import { ReconVelocityTagDefinition } from './tagDefinition';
import { ReconVelocityTaskDefinition } from './taskDefinition';
import { ReconVelocityWorkflow } from './workflow';

export enum ReconVelocityPluginItemReconMode {
  ALL = 'ALL',
  NEW = 'NEW',
  USED = 'USED',
}

export interface ReconVelocityPluginItem extends PluginItem {
  allowSendingNotifications: boolean;
  autoClearCompletedReconVehiclesAfter24Hours: boolean;
  enablePostRecon: boolean;
  restrictMoveStepToStepUserList: boolean;
  enableRequireLaborAndPartsOnTasks: boolean;
  dealershipCosts: ReconVelocityDealershipCosts;
  excludeWholesaleUnitsFromImport: boolean;
  excludeWholesaleUnitsFromImportRemoveRecon: boolean;
  monthlySubscriptionFee: Money;
  onboarding: boolean;
  reconMode: ReconVelocityPluginItemReconMode;
  reconTimeIgnoreSchedule: boolean;
  odometerUnit: OdometerUnit;
  sessionTimeoutAsSeconds: number;
  settings: Record<string, any>;
  tagDefinitions: ReconVelocityTagDefinition[];
  taskDefinitions: ReconVelocityTaskDefinition[];
  workflows: ReconVelocityWorkflow[];
  retailReadyDangerAsSeconds: number;
  reconDangerAsSeconds: number;
}
